import tableDevices from './tableDevices';


export default {
  title: 'Device IDs',
  noArea:true,
  attributeName: 'devices',
  idAttribute: 'id',
  sessionParams: [],
  getURL: 'devices',
  createURL: 'devices',
  updateURL: 'devices',
  removeURL: 'devices',
  tableConfig: tableDevices,
  autoUpdate: true,
};
